import React, { useState, useEffect, useRef } from 'react';
import { Spin } from 'antd';
import { gapi } from 'gapi-script';
import { ListDocuments } from './ListDocuments';
import { useCookies } from 'react-cookie';
import GoogleDriveImage from '../assets/images/google-drive.png';
import spinner from '../assets/images/spinner.gif';
import linkBreak from '../assets/images/LinkBreak.png';
import galogo from '../assets/images/ga-logo.png';
import backImage from '../assets/images/back.png';
import folderImage from '../assets/images/folder.png';
import playIcon from '../assets/images/playicon.png';
import buttonImage from '../assets/images/new-signIn.png';
import './App.css';

// Array of API discovery doc URLs for APIs
const DISCOVERY_DOCS = [
  'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
];

// Authorization scopes required by the API multiple scopes can be
// included, separated by spaces.
const SCOPES = 'https://www.googleapis.com/auth/drive.readonly';

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const API_KEY = process.env.REACT_APP_API_KEY;
const REDIRECT_URL =
  `${document.location.protocol}//${document.location.host}/` ||
  'https://gdplugin.vlogr.com';

export const SelectSource = (props: any) => {
  const { getDriveFileData, axios } = props;

  const [cookies, setCookie, removeCookie] = useCookies();
  const [listDocumentsVisible, setListDocumentsVisibility] = useState(false);
  const [rootId, setRootId] = useState('');
  const [isLoadingGoogleDriveApi, setIsLoadingGoogleDriveApi] = useState(false);
  const [isFetchingGoogleDriveFiles, setIsFetchingGoogleDriveFiles] =
    useState(false);
  const [signedInUser, setSignedInUser] = useState();
  const [gInstance, setGInstance] = useState();
  const [token, setToken] = useState({});
  const googleClient = useRef();
  const [requestUrl, setRequestUrl] = useState('');
  const [isGoogleInitialized, setIsGoogleInitialized] = useState(false);
  const [gapiClient, setGapiClient] = useState({});

  async function googleAccountInit() {
    setTimeout(() => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      // script.async = true;
      // script.defer = true;
      document.body.appendChild(script);
      script.onload = function () {
        /*global google*/
        //@ts-ignore
        googleClient.current = google?.accounts.oauth2.initCodeClient({
          client_id: CLIENT_ID,
          scope: `${SCOPES} openid`,
          ux_mode: 'redirect',
          redirect_uri: REDIRECT_URL,
          access_type: 'offline',
          include_granted_scopes: false,
        });
        setRequestUrl(window.location.href);
      };
    });
    setGapiClient(gapi);
  }

  // async function googleAPIInit() {
  //   const script = document.createElement('script');
  //   script.src = 'https://apis.google.com/js/api.js'
  //   script.async = true;
  //   script.defer = true
  //   document.body.appendChild(script);
  // }

  async function googleClientInit() {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js';
    document.body.appendChild(script);
  }

  /*
    Loading the script and setting the authentication code from window.location.href 
  */
  async function googleInitilization() {
    await googleAccountInit();
    //await googleAPIInit();
    await googleClientInit();
    setIsGoogleInitialized(true);
  }
  useEffect(() => {
    if (!isGoogleInitialized) {
      googleInitilization();
    }
  }, []);

  const getJsonFromUrl = (str: any) => {
    const query = str;
    const result = {};

    query.split('&').forEach((part: any) => {
      const item = part.split('=');
      if (item[0].includes('?')) {
        item[0] = item[0].split('?')[1];
      }
      //@ts-ignore
      result[item[0]] = decodeURIComponent(item[1]);
    });

    return result;
  };
  /*
      Sending the request code to the backend.
     */
  useEffect(() => {
    async function getRequest() {
      //@ts-ignore
      if (requestUrl === '' || token.access_token) {
        return;
      }
      try {
        const result = getJsonFromUrl(requestUrl);
        const res = await axios.post(
          'https://googledrivebk.plugin.vlogr.com/auth-code',
          {
            //@ts-ignore
            requestedUrl: result.code,
            redirectUrl: REDIRECT_URL,
          }
        );
        const backendResponse = res.data;
        if (backendResponse === '') {
          return;
        }
        setCookie('gUser', JSON.stringify(backendResponse));
        setToken(backendResponse);
      } catch (error) {
        console.log(error);
      }
    }
    getRequest();
  }, [requestUrl]);

  function getGoogleOauth() {
    const client = googleClient.current;
    //@ts-ignore
    client.requestCode();
  }

  /**
   * Print files.
   */
  const setParent = async () => {
    setIsFetchingGoogleDriveFiles(true);
    const searchTerm = "'root' in parents";
    const response = await gapi.client.drive.files.list({
      pageSize: 1,
      fields:
        'nextPageToken, files(id, name, mimeType, modifiedTime, thumbnailLink, webViewLink, exportLinks, parents)',
      q: searchTerm,
    });
    const res = JSON.parse(response.body);
    if (Array.isArray(res.files) && res.files.length > 0) {
      setRootId(res.files[0].parents[0]);
    }
  };

  /**
   *  Sign in the user upon button click.
   */
  const handleAuthClick = (event: any) => {
    //@ts-ignore
    gapi.auth2.getAuthInstance().signIn();
  };

  /**
   *  Called when the signed in status changes, to update the UI
   *  appropriately. After a sign-in, the API is called.
   */
  useEffect(() => {
    //@ts-ignore
    if (cookies && token.access_token) {
      handleClientLoad();
    }
  }, [token, cookies]);

  const updateSigninStatus = (isSignedIn: any) => {
    if (isSignedIn || cookies) {
      // Set the signed in user
      if (cookies) {
        //@ts-ignore
        setSignedInUser(cookies);
        setParent();
      } else {
        //@ts-ignore
        setSignedInUser(gapi.auth2.getAuthInstance().currentUser.je.Qt);
        document.cookie = `gUser=${cookies}`;
        setIsLoadingGoogleDriveApi(false);
        setParent();
      }
    } else {
      // prompt user to sign in
      //@ts-ignore
      handleAuthClick();
    }
  };

  /**
   *  Sign out the user upon button click.
   */
  const handleSignOutClick = (event: any) => {
    removeCookie('gUser');
    //@ts-ignore
    setSignedInUser();
    setListDocumentsVisibility(false);
    //@ts-ignore
    gapi.auth2.getAuthInstance().signOut();
    window.location.assign(REDIRECT_URL);
  };

  /**
   loading the directory on reload of the browser
 */
  useEffect(() => {
    const initReloadClient = async () => {
      gapi.client
        .init({
          apiKey: API_KEY,
          clientId: CLIENT_ID,
          discoveryDocs: DISCOVERY_DOCS,
          scope: SCOPES,
          access: 'offline',
        })
        .then(function () {
          // Listen for sign-in state changes.
          gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
          gapi.client.setToken({ access_token: cookies.gUser.access_token });

          // Handle the initial sign-in state.
          updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
          setGInstance(gapi.client);
        });
    };

    window.addEventListener(
      'unload',
      gapi.load('client:auth2', initReloadClient)
    );
  }, []);

  /**
   *  Initializes the API client library and sets up sign-in state
   *  listeners.
   */
  const initClient = async () => {
    gapi.client
      .init({
        apiKey: API_KEY,
        clientId: CLIENT_ID,
        discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
        access: 'offline',
      })
      .then(function () {
        // Listen for sign-in state changes.
        //@ts-ignore
        gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);
        //@ts-ignore
        gapi.client.setToken({ access_token: token.access_token });

        // Handle the initial sign-in state.
        //@ts-ignore
        updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
        //@ts-ignore
        setGInstance(gapi.client);
      });
  };

  const handleClientLoad = async () => {
    gapi.load('client', initClient);
  };

  const showDocuments = () => {
    setListDocumentsVisibility(true);
  };

  const onClose = () => {
    setListDocumentsVisibility(false);
  };

  return (
    <div className="googleDriveApp">
      {signedInUser || cookies.gUser ? (
        <ListDocuments
          visible={listDocumentsVisible}
          onClose={onClose}
          documents={[]}
          directories={[]}
          rootId={rootId}
          token={token}
          signedInUser={signedInUser}
          onSignOut={handleSignOutClick}
          isLoading={isFetchingGoogleDriveFiles}
          gapiClient={gInstance}
          cookies={cookies}
          spinner={spinner}
          linkBreak={linkBreak}
          galogo={galogo}
          backImage={backImage}
          folderImage={folderImage}
          playIcon={playIcon}
          getDriveFileData={getDriveFileData}
        />
      ) : (
        <div>
          <Spin spinning={isLoadingGoogleDriveApi} style={{ width: '100%' }}>
            <div
              className="googleDriveApp-source-container"
              style={{ paddingTop: '35%' }}
            >
              <div className="content-container">
                <span className="content, googleDriveApp-get-started">
                  Get started by connecting your account
                </span>
              </div>
              <div className="icon-container" style={{ paddingTop: '40px' }}>
                <div className="icon icon-success">
                  <img height="100px" width="100px" src={GoogleDriveImage} />
                </div>
              </div>
              <div
                className={'content-container'}
                style={{ paddingTop: '50px' }}
                onClick={() => getGoogleOauth()}
              >
                <img
                  src={buttonImage}
                  style={{ cursor: 'pointer', height: '50px' }}
                  alt="button_image"
                />
              </div>
            </div>
          </Spin>
        </div>
      )}
    </div>
  );
};
